export const PRESENTATION_PLAN_CONTRACT = "activity_presentation_plan.v1";

let fallbackSequence = 0;

export function createOccurrenceKey(existingKeys = new Set()) {
  let candidate;
  do {
    const browserUuid = typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function"
      ? window.crypto.randomUUID()
      : null;
    fallbackSequence += 1;
    candidate = `occurrence-${browserUuid || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${fallbackSequence.toString(36)}`}`;
  } while (existingKeys.has(candidate));
  return candidate;
}

export function reconcilePresentationPlan(plan, selectedIds) {
  const selected = new Set(selectedIds);
  const source = plan?.contractVersion === PRESENTATION_PLAN_CONTRACT ? plan : {
    contractVersion: PRESENTATION_PLAN_CONTRACT,
    coverage: plan?.mode === "random" ? "random_subset" : "all",
    requestedCount: plan?.requestedCount ?? null,
    ordering: plan?.mode === "random" ? "randomized" : "fixed",
    occurrences: [],
  };
  const occurrences = (source.occurrences || []).filter(item => selected.has(item.stimulusInstanceId));
  const bases = new Map(occurrences.filter(item => !item.parentOccurrenceKey).map(item => [item.stimulusInstanceId, item]));
  const existingKeys = new Set(occurrences.map(item => item.occurrenceKey));
  selectedIds.forEach(stimulusInstanceId => {
    if (!bases.has(stimulusInstanceId)) {
      const occurrenceKey = createOccurrenceKey(existingKeys);
      existingKeys.add(occurrenceKey);
      const base = { occurrenceKey, stimulusInstanceId, parentOccurrenceKey: null };
      bases.set(stimulusInstanceId, base); occurrences.push(base);
    }
  });
  const validKeys = new Set(bases.values().map(item => item.occurrenceKey));
  return {
    contractVersion: PRESENTATION_PLAN_CONTRACT,
    coverage: source.coverage === "random_subset" ? "random_subset" : "all",
    requestedCount: source.coverage === "random_subset" ? source.requestedCount ?? null : null,
    ordering: source.ordering === "randomized" ? "randomized" : "fixed",
    occurrences: occurrences.filter(item => !item.parentOccurrenceKey || validKeys.has(item.parentOccurrenceKey)),
  };
}

export function addRepeat(plan, stimulusInstanceId) {
  const base = plan.occurrences.find(item => !item.parentOccurrenceKey && item.stimulusInstanceId === stimulusInstanceId);
  if (!base) return plan;
  return { ...plan, occurrences: [...plan.occurrences, {
    occurrenceKey: createOccurrenceKey(new Set(plan.occurrences.map(item => item.occurrenceKey))), stimulusInstanceId, parentOccurrenceKey: base.occurrenceKey,
  }] };
}
